
        <div *ngIf="text.enabled()" class="text-day">
          <h2>Account Summary</h2>
          <p *ngIf="activityStore.accountStatsSnapshot() as stats">
            Time in activities <strong>{{ activityStore.statsPending() ? '—' : ps.formatSecondsToHoursMinutes(stats.totalActivityTime || stats.totalTime) }}</strong>
            <span *ngIf="!activityStore.statsPending() && stats.bungieTotalTime"
                  class="text-day-dim"
                  title="Bungie character playtime including orbit, Tower, and social spaces">
              · Bungie total {{ ps.formatSecondsToHoursMinutes(stats.bungieTotalTime) }}
            </span>
            · Seals <strong>{{ activityStore.statsPending() ? '—' : (stats.totalSeals || 0) }}</strong>
            · Activities <strong>{{ activityStore.statsPending() ? '—' : stats.totalActivityCount }}</strong>
          </p>
          <div *ngIf="ps.perPlatformStats.length > 0" class="text-accounts">
            <p class="text-day-dim">Accounts. Select one or more. No selection = all accounts.</p>
            <button *ngFor="let plat of ps.perPlatformStats"
                    type="button"
                    class="text-account"
                    [class.on]="ps.selectedAccountKeysForActivities.has(plat.accountKey)"
                    (click)="ps.onAccountSummaryCardToggle(plat.accountKey)">
              {{ plat.displayName || plat.platform }} · {{ plat.platform }} · {{ plat.game }}
            </button>
          </div>
          <p class="text-day-date">Date: <strong>{{ ps.formatSelectedDateLabel() }}</strong>
            <span class="text-day-dim" *ngIf="!ps.loadingActivities[ps.selectedDate] && !ps.profileLoadInProgress"> · {{ ps.formatSecondsToHoursMinutes(ps.totalTimeForSelectedDate) }}</span>
          </p>
          <div *ngIf="ps.showAnniversaryBanner && ps.anniversaryFirsts.length > 0" class="text-day-banner">
            <p *ngFor="let anniversary of ps.anniversaryFirsts">
              Guardian Firsts anniversary — {{ anniversary.yearsAgo }} years ago today:
              <strong>{{ anniversary.activityName }}</strong>
              ({{ anniversary.dateLabel || ps.formatDate(anniversary.completionDate) }})
            </p>
          </div>
          <p *ngIf="ps.loadingActivities[ps.selectedDate] || ps.profileLoadInProgress" class="text-day-dim">Loading activities…</p>
          <ng-container *ngIf="!ps.loadingActivities[ps.selectedDate] && !ps.profileLoadInProgress">
            <ng-container *ngIf="textDay() as day">
              <section *ngFor="let section of day.sections">
                <h2>{{ section.year }} <span class="text-day-dim">{{ section.game === 'D1' ? 'Destiny 1' : 'Destiny 2' }}</span></h2>
                <div *ngFor="let row of section.rows; trackBy: ps.trackByChronologicalRow" class="text-day-row">
                  <span class="text-day-dim">{{ ps.formatTime(row.activity.period) }}</span>
                  <span class="text-day-name">{{ row.activityName }}</span>
                  <span>{{ row.activityType }}</span>
                  <span [class.text-day-ok]="ps.isActivityCompleted(row.activity)" [class.text-day-no]="!ps.isActivityCompleted(row.activity)">
                    {{ ps.isActivityCompleted(row.activity) ? 'Completed' : 'Not completed' }}
                  </span>
                  <span>{{ ps.formatSecondsToHoursMinutes(ps.getActivityDurationSeconds(row.activity)) }}</span>
                  <button type="button" class="text-day-link" (click)="ps.openExternalPGCR(row.activity, row.isD1, $event)">PGCR</button>
                </div>
              </section>
              <p *ngIf="day.total === 0" class="text-day-dim">No activities found for this date.</p>
            </ng-container>
          </ng-container>
        </div>

        <!-- Headline stats + account cards live in the dossier header -->
        
        <!-- Anniversary Celebration Banner -->
        <app-anniversary-celebration-banner
          *ngIf="!text.enabled() && ps.showAnniversaryBanner && ps.anniversaryFirsts.length > 0"
          [anniversaries]="ps.anniversaryFirsts"
          [selectedDate]="ps.selectedDate"
          (dismiss)="ps.onDismissAnniversaryBanner()"
          (navigateToFirst)="ps.onNavigateToAnniversary($event)"
          (shareMemory)="ps.onShareAnniversaryMemory($event)">
        </app-anniversary-celebration-banner>
        
        <!-- Date/new-lookup progress is the header strip only — no second engram here -->
        
        <!-- Skeleton Loader for Activities to Prevent Layout Shifts -->
        <div *ngIf="!text.enabled() && ps.loadingActivities[ps.selectedDate]" class="space-y-6 w-full min-w-0">
          <!-- Destiny 2 Skeleton -->
          <div class="space-y-6">
            <div class="flex items-center mb-4">
              <div class="w-6 h-6 destiny-skeleton mr-2"></div>
              <div class="w-32 h-8 destiny-skeleton"></div>
                </div>
            <div class="destiny-surface-panel overflow-hidden p-4">
              <div class="mb-8 destiny-year-block p-4">
                <div class="flex items-center mb-4">
                  <div class="w-20 h-8 destiny-skeleton mr-3"></div>
                  <div class="w-48 h-6 destiny-skeleton"></div>
              </div>
                <div *ngIf="ps.activitiesViewMode === 'cards'" class="flex flex-col md:flex-row md:flex-wrap gap-6">
                  <div class="w-full md:flex-1 md:min-w-[280px] md:max-w-[400px]">
                    <div class="flex items-center mb-2 gap-3">
                      <div class="w-20 h-20 destiny-skeleton"></div>
                      <div class="w-32 h-6 destiny-skeleton"></div>
              </div>
                    <div class="space-y-2">
                      <div class="h-12 destiny-skeleton"></div>
                      <div class="h-12 destiny-skeleton"></div>
                      <div class="h-12 destiny-skeleton"></div>
            </div>
              </div>
              </div>
                <div *ngIf="ps.activitiesViewMode === 'chronological'" class="space-y-2">
                  <div class="h-14 destiny-skeleton"></div>
                  <div class="h-14 destiny-skeleton"></div>
                  <div class="h-14 destiny-skeleton"></div>
                  <div class="h-14 destiny-skeleton"></div>
                </div>
              </div>
            </div>
              </div>
          
          <!-- Destiny 1 Skeleton -->
          <div class="space-y-6 mt-10">
            <div class="flex items-center mb-4">
              <div class="w-6 h-6 destiny-skeleton mr-2"></div>
              <div class="w-32 h-8 destiny-skeleton"></div>
            </div>
            <div class="destiny-surface-panel overflow-hidden p-4">
              <div class="mb-8 destiny-year-block p-4">
                <div class="flex items-center mb-4">
                  <div class="w-20 h-8 destiny-skeleton mr-3"></div>
                  <div class="w-32 h-6 destiny-skeleton"></div>
                    </div>
                <div *ngIf="ps.activitiesViewMode === 'cards'" class="flex flex-col md:flex-row md:flex-wrap gap-6">
                  <div class="w-full md:flex-1 md:min-w-[280px] md:max-w-[400px]">
                    <div class="flex items-center mb-2 gap-3">
                      <div class="w-20 h-20 destiny-skeleton"></div>
                      <div class="w-32 h-6 destiny-skeleton"></div>
                    </div>
                    <div class="space-y-2">
                      <div class="h-12 destiny-skeleton"></div>
                      <div class="h-12 destiny-skeleton"></div>
                      <div class="h-12 destiny-skeleton"></div>
                  </div>
                </div>
              </div>
                <div *ngIf="ps.activitiesViewMode === 'chronological'" class="space-y-2">
                  <div class="h-14 destiny-skeleton"></div>
                  <div class="h-14 destiny-skeleton"></div>
                  <div class="h-14 destiny-skeleton"></div>
                  <div class="h-14 destiny-skeleton"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!text.enabled() && !ps.loadingActivities[ps.selectedDate] && (ps.groupedActivitiesByAccount && ps.groupedActivitiesByAccount.length > 0)"
             class="space-y-6 w-full min-w-0 activities-glass-view">
          <!-- Total time on the selected date for all activities -->
          <div class="destiny-surface-panel p-4 flex flex-wrap items-center justify-between gap-2">
            <span class="text-slate-300">Total time on the selected date for all activities ({{ ps.formatSelectedDateLabel() }})<span *ngIf="ps.hasAccountFilterForActivities" class="block text-xs text-[var(--destiny-gold)]/90 mt-1">Showing selected accounts only</span></span>
            <div class="flex flex-wrap items-center gap-2">
              <button type="button"
                      class="activity-toolbar-btn"
                      (click)="ps.collapseAllActivityYears()">
                {{ ps.uiI18n.t('activities.collapseAllYears') }}
              </button>
              <button type="button"
                      class="activity-toolbar-btn"
                      (click)="ps.expandAllActivityYears()">
                {{ ps.uiI18n.t('activities.expandAllYears') }}
              </button>
              <div class="activity-view-segment" role="group" [attr.aria-label]="ps.uiI18n.t('activities.viewCards')">
                <button type="button"
                        class="activity-segment-btn"
                        [class.activity-segment-btn-active]="ps.activitiesViewMode === 'cards'"
                        (click)="ps.setActivitiesViewMode('cards')">
                  {{ ps.uiI18n.t('activities.viewCards') }}
                </button>
                <button type="button"
                        class="activity-segment-btn"
                        [class.activity-segment-btn-active]="ps.activitiesViewMode === 'chronological'"
                        (click)="ps.setActivitiesViewMode('chronological')">
                  {{ ps.uiI18n.t('activities.viewChronological') }}
                </button>
              </div>
              <div *ngIf="ps.activitiesViewMode === 'chronological'"
                   class="activity-view-segment"
                   role="group"
                   [attr.aria-label]="ps.uiI18n.t('activities.sortOldest')">
                <button type="button"
                        class="activity-segment-btn"
                        [class.activity-segment-btn-active]="ps.activitiesChronologicalSort === 'oldest'"
                        (click)="ps.setActivitiesChronologicalSort('oldest')">
                  {{ ps.uiI18n.t('activities.sortOldest') }}
                </button>
                <button type="button"
                        class="activity-segment-btn"
                        [class.activity-segment-btn-active]="ps.activitiesChronologicalSort === 'newest'"
                        (click)="ps.setActivitiesChronologicalSort('newest')">
                  {{ ps.uiI18n.t('activities.sortNewest') }}
                </button>
              </div>
              <span class="text-xl font-bold text-[var(--destiny-gold)] font-mono">{{ ps.formatSecondsToHoursMinutes(ps.totalTimeForSelectedDate) }}</span>
            </div>
          </div>
          <!-- Destiny 2 Panel -->
          <div *ngIf="ps.getDisplayedAccountGroupsForGame('D2').length > 0" class="space-y-6">
            <button type="button"
                    class="activity-collapse-toggle flex items-center gap-2 mb-4 w-full text-left group"
                    (click)="ps.toggleActivityGameCollapsed('D2')"
                    [attr.aria-expanded]="!ps.isActivityGameCollapsed('D2')"
                    [attr.aria-label]="ps.isActivityGameCollapsed('D2') ? ps.uiI18n.t('activities.show') + ' Destiny 2' : ps.uiI18n.t('activities.hide') + ' Destiny 2'">
              <img [src]="ps.getGameIconUrl('D2')" class="w-6 h-6 flex-shrink-0" alt="" />
              <h2 class="text-2xl font-bold text-d2-gold m-0">Destiny 2</h2>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 ml-auto text-slate-400 group-hover:text-slate-200 flex-shrink-0 transition-transform"
                   fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"
                   [class.-rotate-90]="ps.isActivityGameCollapsed('D2')">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div *ngIf="!ps.isActivityGameCollapsed('D2')">
            <div *ngFor="let gameGroup of ps.getDisplayedAccountGroupsForGame('D2'); trackBy: ps.trackByAccountGroup" class="destiny-surface-panel p-4">
              <div *ngFor="let yearGroup of gameGroup.yearGroups; trackBy: ps.trackByYearGroup" class="destiny-year-block mb-8 p-4">
                <button type="button"
                        class="activity-collapse-toggle activity-year-heading flex items-center mb-4 w-full text-left group"
                        (click)="ps.toggleActivityYearCollapsed('D2', yearGroup.year)"
                        [attr.aria-expanded]="!ps.isActivityYearCollapsed('D2', yearGroup.year)"
                        [attr.aria-label]="(ps.isActivityYearCollapsed('D2', yearGroup.year) ? ps.uiI18n.t('activities.expand') : ps.uiI18n.t('activities.collapse')) + ' ' + yearGroup.year">
                  <span class="activity-year-label text-2xl font-bold text-[var(--destiny-gold)] mr-3">{{ yearGroup.year }}</span>
                  <span *ngIf="ps.getSeasonForYear('D2', yearGroup.year) as season" class="text-[#f0e6c8]/80 text-lg">({{ season }})</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 ml-auto text-slate-400 group-hover:text-slate-200 flex-shrink-0 transition-transform"
                       fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"
                       [class.-rotate-90]="ps.isActivityYearCollapsed('D2', yearGroup.year)">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div *ngIf="!ps.isActivityYearCollapsed('D2', yearGroup.year)">
                  <ng-container *ngIf="ps.activitiesViewMode === 'cards'">
                    <ng-container *ngTemplateOutlet="yearActivitiesCards; context: { game: 'D2', yearGroup: yearGroup, gameGroup: gameGroup }"></ng-container>
                  </ng-container>
                  <ng-container *ngIf="ps.activitiesViewMode === 'chronological'">
                    <ng-container *ngTemplateOutlet="yearActivitiesChronological; context: { game: 'D2', yearGroup: yearGroup }"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            </div>
          </div>

          <!-- Destiny 1 Panel -->
          <div *ngIf="ps.getDisplayedAccountGroupsForGame('D1').length > 0" class="space-y-6 mt-10">
            <button type="button"
                    class="activity-collapse-toggle flex items-center gap-2 mb-4 w-full text-left group"
                    (click)="ps.toggleActivityGameCollapsed('D1')"
                    [attr.aria-expanded]="!ps.isActivityGameCollapsed('D1')"
                    [attr.aria-label]="ps.isActivityGameCollapsed('D1') ? ps.uiI18n.t('activities.show') + ' Destiny 1' : ps.uiI18n.t('activities.hide') + ' Destiny 1'">
              <img [src]="ps.getGameIconUrl('D1')" class="w-6 h-6 flex-shrink-0" alt="" />
              <h2 class="text-2xl font-bold text-d1-silver m-0">Destiny 1</h2>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 ml-auto text-slate-400 group-hover:text-slate-200 flex-shrink-0 transition-transform"
                   fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"
                   [class.-rotate-90]="ps.isActivityGameCollapsed('D1')">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div *ngIf="!ps.isActivityGameCollapsed('D1')">
            <div *ngFor="let gameGroup of ps.getDisplayedAccountGroupsForGame('D1'); trackBy: ps.trackByAccountGroup" class="destiny-surface-panel p-4">
              <div *ngFor="let yearGroup of gameGroup.yearGroups; trackBy: ps.trackByYearGroup" class="destiny-year-block mb-8 p-4">
                <button type="button"
                        class="activity-collapse-toggle activity-year-heading flex items-center mb-4 w-full text-left group"
                        (click)="ps.toggleActivityYearCollapsed('D1', yearGroup.year)"
                        [attr.aria-expanded]="!ps.isActivityYearCollapsed('D1', yearGroup.year)"
                        [attr.aria-label]="(ps.isActivityYearCollapsed('D1', yearGroup.year) ? ps.uiI18n.t('activities.expand') : ps.uiI18n.t('activities.collapse')) + ' ' + yearGroup.year">
                  <span class="activity-year-label text-2xl font-bold text-d1-silver mr-3">{{ yearGroup.year }}</span>
                  <span *ngIf="ps.getSeasonForYear('D1', yearGroup.year) as season" class="text-slate-300/80 text-lg">({{ season }})</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 ml-auto text-slate-400 group-hover:text-slate-200 flex-shrink-0 transition-transform"
                       fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"
                       [class.-rotate-90]="ps.isActivityYearCollapsed('D1', yearGroup.year)">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div *ngIf="!ps.isActivityYearCollapsed('D1', yearGroup.year)">
                  <ng-container *ngIf="ps.activitiesViewMode === 'cards'">
                    <ng-container *ngTemplateOutlet="yearActivitiesCards; context: { game: 'D1', yearGroup: yearGroup, gameGroup: gameGroup }"></ng-container>
                  </ng-container>
                  <ng-container *ngIf="ps.activitiesViewMode === 'chronological'">
                    <ng-container *ngTemplateOutlet="yearActivitiesChronological; context: { game: 'D1', yearGroup: yearGroup }"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            </div>
          </div>
          <dc-empty-state *ngIf="ps.activityFilterPreset !== 'all' && ps.getDisplayedAccountGroupsForGame('D2').length === 0 && ps.getDisplayedAccountGroupsForGame('D1').length === 0"
               kind="none"
               class="p-4 text-sm">
            No activities match the selected filter for this date.
          </dc-empty-state>
        </div>
        <dc-empty-state *ngIf="!text.enabled() && !ps.loadingActivities[ps.selectedDate] && (!ps.groupedActivitiesByAccount || ps.groupedActivitiesByAccount.length === 0)"
             kind="none">
          No activities found for this date.
        </dc-empty-state>
<ng-template #yearActivitiesCards let-game="game" let-yearGroup="yearGroup" let-gameGroup="gameGroup">
  <div class="activity-cards-grid" (click)="ps.onActivityReportClick($event)">
    <div *ngFor="let typeGroup of yearGroup.typeGroups; trackBy: ps.trackByTypeGroup" class="activity-card-column">
      <div class="flex items-start mb-2 gap-3 min-w-0">
        <ng-container *ngIf="ps.getActivityImage(typeGroup.activities[0], typeGroup.activities[0]?.game === 'D1') as img">
          <img *ngIf="img && typeof img === 'string'" [src]="img" class="w-16 h-16 object-cover rounded shadow shrink-0 pgcr-thumb" />
          <span *ngIf="img && typeof img !== 'string'" class="activity-image shrink-0" [innerHTML]="img"></span>
        </ng-container>
        <span class="font-semibold text-slate-200 text-base min-w-0 break-words leading-snug">
          {{ typeGroup.name }}<span *ngIf="typeGroup.type"> / {{ typeGroup.type | titlecase }}</span>
        </span>
      </div>
      <div class="grid grid-cols-1 gap-2">
        <div *ngFor="let versionGroup of ps.getVersionGroups(typeGroup.activities); trackBy: ps.trackByVersionGroup" class="mb-3 pl-2 min-w-0 border-l border-[rgba(201,162,39,0.15)]">
          <div class="flex flex-wrap items-center gap-1 mb-1.5">
            <span class="activity-version-label">{{ versionGroup.version }}</span>
            <span class="activity-version-count">
              ({{ versionGroup.activities.length }} {{ versionGroup.activities.length === 1 ? 'completion' : 'completions' }})
            </span>
          </div>
          <div *ngFor="let activity of versionGroup.activities; trackBy: ps.trackByActivity"
               class="activity-card-row activity-row min-w-0"
               [ngStyle]="{ '--activity-accent': ps.getActivityTypeAccent(typeGroup.type) }">
            <div class="activity-row-meta" *ngIf="ps.selectedPlayers.length > 1">
              <img [src]="ps.getGameIconUrl((activity.game || gameGroup.game) === 'D1' ? 'D1' : 'D2')" class="w-4 h-4 shrink-0 object-contain" alt="game" />
              <img [src]="ps.getPlatformIconUrl(activity.membershipType || 0)" class="w-4 h-4 platform-icon" alt="platform" />
              <img *ngIf="activity.characterClass as cls" [src]="ps.getClassIconUrl(cls)" class="w-4 h-4 shrink-0" [title]="cls" alt="class" />
            </div>
            <span *ngIf="ps.selectedPlayers.length > 1" class="activity-row-name text-xs font-medium">{{ ps.getActivityDisplayName(activity) }}</span>
            <span *ngIf="ps.selectedPlayers.length <= 1" class="activity-row-name activity-row-name--spacer" aria-hidden="true"></span>
            <button type="button"
                    [attr.data-instance-id]="activity.activityDetails?.instanceId"
                    [attr.data-d1]="(activity.game || gameGroup.game) === 'D1' ? '1' : '0'"
                    [title]="ps.uiI18n.t('pgcr.openReportHint')"
                    class="activity-pgcr-link activity-pgcr-link--card">
              {{ ps.formatTime(activity.period) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #yearActivitiesChronological let-game="game" let-yearGroup="yearGroup">
  <div class="space-y-2" (click)="ps.onActivityReportClick($event)">
    <div *ngFor="let row of ps.getChronologicalRowsForYear(yearGroup, game); trackBy: ps.trackByChronologicalRow"
         class="activity-chrono-row activity-row destiny-panel destiny-panel--compact flex items-center gap-2 min-w-0 transition-colors"
         [ngStyle]="{ '--activity-accent': ps.getActivityTypeAccent(row.activityType) }">
      <ng-container *ngIf="ps.getActivityImage(row.activity, row.isD1) as img">
        <img *ngIf="img && typeof img === 'string'" [src]="img" class="activity-chrono-thumb w-14 h-14 object-cover rounded shadow shrink-0 pgcr-thumb" alt="" />
        <span *ngIf="img && typeof img !== 'string'" class="activity-chrono-thumb activity-image shrink-0" [innerHTML]="img"></span>
      </ng-container>
      <span class="text-sm text-slate-200 font-medium truncate min-w-0 flex-1">
        {{ row.activityName }}<span *ngIf="row.activityType" class="text-slate-400"> / {{ row.activityType | titlecase }}</span>
      </span>
      <span class="text-xs font-medium text-[var(--destiny-gold)] bg-black/30 border border-[var(--destiny-gold)]/30 px-2 py-1 rounded shrink-0">{{ row.version }}</span>
      <img [src]="ps.getGameIconUrl((row.game || game) === 'D1' ? 'D1' : 'D2')" class="w-4 h-4 shrink-0 object-contain" alt="game" />
      <img [src]="ps.getPlatformIconUrl(row.activity.membershipType || 0)" class="w-4 h-4 platform-icon shrink-0" alt="platform" />
      <span class="text-xs text-slate-300 font-medium truncate shrink-0 max-w-[120px]">{{ ps.getActivityDisplayName(row.activity) }}</span>
      <button type="button"
              [attr.data-instance-id]="row.activity.activityDetails?.instanceId"
              [attr.data-d1]="(row.game || game) === 'D1' ? '1' : '0'"
              [title]="ps.uiI18n.t('pgcr.openReportHint')"
              class="activity-pgcr-link text-xs font-mono shrink-0">
        {{ ps.formatTime(row.activity.period) }}
      </button>
    </div>
  </div>
</ng-template>
